import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=0009755c&"
import script from "./ReviewStep.vue?vue&type=script&lang=js&"
export * from "./ReviewStep.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStep.vue?vue&type=style&index=0&id=0009755c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports